import { BaseEntity } from 'src/app/tools/models/baseEntity'
import { PartnerCategory } from './partner-category-entity';


export class PartnerCategoryType extends BaseEntity {

    partnerCategory         : PartnerCategory = new PartnerCategory();
    partnerCategoryTypeCode : string;
    name                    : string;
    rank                    : number;
}

